<template>
  <div class="categories-container">
    <h4 class="categories-title">Categories</h4>
    <b-card-group deck class="categories-deck">
      <b-card
        title="Show All"
        img-src="/img/logo.68852ff1.png"
        img-alt="Personalised Gifts Image"
        img-top
        class="text-center"
      >
      </b-card>
      <b-card
        title="Education"
        img-src="/img/logo.68852ff1.png"
        img-alt="Clothing Image"
        img-top
        class="text-center"
      >
      </b-card>
      <b-card
        title="Business"
        img-src="/img/logo.68852ff1.png"
        img-alt="Image"
        img-top
        class="Essential Oil text-center"
      >
      </b-card>
      <b-card
        title="Surprise Me"
        img-src="/img/logo.68852ff1.png"
        img-alt="Jewellery Image"
        img-top
        class="text-center"
      >
      </b-card>
    </b-card-group>
  </div>
</template>

<script>
export default {
  name: "CategoriesCards",
  components: {},
};
</script>

<style scoped lang="scss">
$light-gray: #e7e7e7;

.categories-title {
  font-weight: 700;
  margin-bottom: 3rem;
}

div.card {
  border: none;
  display: inline-block;
}

.card-img-top {
  border-radius: 50%;
  vertical-align: middle;
  background-color: $light-gray;
  width: 160px;
  height: 160px;
  filter: drop-shadow(0 0.5rem 0.25rem rgba(0, 0, 0, 0.2));
}

h4.card-title {
  font-size: 16px;
}

@media screen and (max-width: 767px) {
  div.card-deck.categories-deck {
    display: grid;
  }
}
</style>
